export const countMessagesSentByQuarterHourOfWeek = {
  analysisType: 'count',
  eventCollection: 'message.sent',
  groupBy: 'time.quarter_hour_of_week',
  key: 'countMessagesSentByQuarterHourOfWeek',
}
